import React from "react";
import { Container } from "basis";

import { Accounts } from "./Accounts";
import { Text } from "../../../components";
import { COLOR } from "../../../components/theme";

export const PaymentMethod = ({
  disabled = false,
  accounts,
  onChange,
  label = "Using account:"
}) => {
  return (
    <>
      <Container>
        <Text textStyle="heading5" margin="8 0 2" color={COLOR.LATITUDE_BLUE_INDIGO} fontFamily="LatitudeSans">
          Your account
        </Text>

        <Text margin="0 0 4" color={COLOR.LATITUDE_BLUE_INDIGO}>
          {label}
        </Text>
      </Container>

      {accounts?.length > 0 && (
        <Container margin="0" border>
          <Accounts
            disabled={disabled}
            accounts={accounts}
            onChange={onChange}
          />
        </Container>
      )}
    </>
  );
};
